export const DEFAULT_DURATION_STRING_FORMAT = 'DD[d] HH[h] mm[m] ss[s]';
